import Component from '$store/components/product/AddToCartButton/vtex.tsx'
import type { Props } from '$store/components/product/AddToCartButton/vtex.tsx'

function Island(props: Props) {
	return <Component {...props} />
}

export default Island
